__turbopack_context__.v({
  "article": "CRealizations-module__VVLFaW__article",
  "articleBenefits": "CRealizations-module__VVLFaW__articleBenefits",
  "articleBox": "CRealizations-module__VVLFaW__articleBox",
  "articleBoxLabel": "CRealizations-module__VVLFaW__articleBoxLabel",
  "articleBoxValue": "CRealizations-module__VVLFaW__articleBoxValue",
  "articleBoxes": "CRealizations-module__VVLFaW__articleBoxes",
  "articleGallery": "CRealizations-module__VVLFaW__articleGallery",
  "articleHero": "CRealizations-module__VVLFaW__articleHero",
  "articleHeroBack": "CRealizations-module__VVLFaW__articleHeroBack",
  "articleHeroBackLink": "CRealizations-module__VVLFaW__articleHeroBackLink",
  "articleHeroBadge": "CRealizations-module__VVLFaW__articleHeroBadge",
  "articleHeroClient": "CRealizations-module__VVLFaW__articleHeroClient",
  "articleHeroContent": "CRealizations-module__VVLFaW__articleHeroContent",
  "articleHeroInner": "CRealizations-module__VVLFaW__articleHeroInner",
  "articleHeroLogo": "CRealizations-module__VVLFaW__articleHeroLogo",
  "articleHeroMeta": "CRealizations-module__VVLFaW__articleHeroMeta",
  "articleHeroMetaSep": "CRealizations-module__VVLFaW__articleHeroMetaSep",
  "articleHeroNoImage": "CRealizations-module__VVLFaW__articleHeroNoImage",
  "articleHeroOverlay": "CRealizations-module__VVLFaW__articleHeroOverlay",
  "articleHeroSector": "CRealizations-module__VVLFaW__articleHeroSector",
  "articleHeroTitle": "CRealizations-module__VVLFaW__articleHeroTitle",
  "articleIntro": "CRealizations-module__VVLFaW__articleIntro",
  "articleOnlineBtn": "CRealizations-module__VVLFaW__articleOnlineBtn",
  "articleOnlineBtnIcon": "CRealizations-module__VVLFaW__articleOnlineBtnIcon",
  "articleQuote": "CRealizations-module__VVLFaW__articleQuote",
  "articleQuoteAuthor": "CRealizations-module__VVLFaW__articleQuoteAuthor",
  "articleQuoteAuthorRole": "CRealizations-module__VVLFaW__articleQuoteAuthorRole",
  "articleQuoteAuthorSep": "CRealizations-module__VVLFaW__articleQuoteAuthorSep",
  "articleQuoteFooter": "CRealizations-module__VVLFaW__articleQuoteFooter",
  "articleSection": "CRealizations-module__VVLFaW__articleSection",
  "articleSectionBenefits": "CRealizations-module__VVLFaW__articleSectionBenefits",
  "articleSectionBody": "CRealizations-module__VVLFaW__articleSectionBody",
  "articleSectionSteps": "CRealizations-module__VVLFaW__articleSectionSteps",
  "articleSectionTags": "CRealizations-module__VVLFaW__articleSectionTags",
  "articleSectionTitle": "CRealizations-module__VVLFaW__articleSectionTitle",
  "articleSteps": "CRealizations-module__VVLFaW__articleSteps",
  "articleTag": "CRealizations-module__VVLFaW__articleTag",
  "articleTags": "CRealizations-module__VVLFaW__articleTags",
  "empty": "CRealizations-module__VVLFaW__empty",
  "galleryGrid": "CRealizations-module__VVLFaW__galleryGrid",
  "galleryItem": "CRealizations-module__VVLFaW__galleryItem",
  "grid": "CRealizations-module__VVLFaW__grid",
  "hero": "CRealizations-module__VVLFaW__hero",
  "root": "CRealizations-module__VVLFaW__root",
  "tabPill": "CRealizations-module__VVLFaW__tabPill",
  "tabPillActive": "CRealizations-module__VVLFaW__tabPillActive",
  "tabs": "CRealizations-module__VVLFaW__tabs",
});
